module.exports = __webpack_public_path__ + "images/emoji/scorpius.ea22fba1c4ed17fe231c.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/scorpius.png
// module id = PYxC
// module chunks = 2